/**
 * Business entity model — ES module version of MyScripts/Entities/Business.ts
 */

import type { BusinessData, PhoneNumberData, EmailData, AttachmentData, WarningData, ConnectionsData } from '@/services/api-types';

export type { BusinessData };

export function createBusiness(data?: Partial<BusinessData>): BusinessData {
  return {
    id: null,
    businessName: null,
    branchName: null,
    website: null,
    businessType: null,
    notes: null,
    locName: null,
    locAddress: null,
    locAddress2: null,
    locCity: null,
    locState: null,
    locZip: null,
    locCountry: null,
    locFormattedAddress: null,
    latitude: null,
    longitude: null,
    customLocationId: null,
    emails: [],
    descriptionPicInfoId: null,
    attachmentList: [],
    createdByCompanyId: null,
    createdByCompanyName: null,
    phoneNumbers: [],
    warnings: [],
    connections: { people: [], vehicles: [], clients: [], businesses: [], reports: [] },
    ...data,
  };
}
